import { Store } from '@ngrx/store';
import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {ModalState} from 'app/analytics/models';
import { ModalState as CameraModal } from 'app/cameras/models';
import {AnalyticActions} from 'app/analytics/Services/actions';
import {Associate} from 'app/Login/models';
import {OperationStatus, ResultAlert} from 'app/Shared/models';
import {SharedService} from 'app/Shared/Services/shared.service';
import {ValidationResponseHandlerModule} from 'app/Shared/ValidationResponse/validation-response-handler';
import {AppState} from 'app/store/model';
import { UserInventory } from 'app/Users/models';
import {UserService} from 'app/Users/Services/user.service';
import {environment} from 'environments/environment';
import Hls from 'hls.js';
import {filter, of, Subject, Subscription, switchMap, take, tap} from 'rxjs';
import Swal from 'sweetalert2';
import {AnalyticTypes, Camera, CameraId, ListType, Mosaic, PaginationCameras} from '../models';
import {CameraActions} from '../Services/actions';
import {CameraService} from '../Services/camera.service';
import {ImageService} from 'app/Shared/Services/image.service';
import _ from 'lodash';
import { UserActions } from 'app/Users/Services/actions';
import { ShareDataService } from 'app/Shared/Services/share-data.service';

@Component({
    selector: 'app-camera-view',
    templateUrl: './camera-view.component.html',
    styleUrls: ['./camera-view.component.scss'],
    standalone: false
})
export class CameraViewComponent implements OnInit, AfterViewInit, OnDestroy {
    readonly modal_open$ = this.store.select((state: AppState) => state.camera.modal_open_invite_user);
    readonly modal_open_camera$ = this.store.select((state: AppState) => state.camera.modal_open_update_camera);
    readonly upCam$ = this.store.select((state: AppState) => state.camera.updateCam);
    readonly camera$ = this.store.select((state: AppState) => state.camera.camera_view);
    readonly cameras$ = this.store.select((state: AppState) => state.camera.cameras);
    readonly camerasShared$ = this.store.select((state: AppState) => state.camera.cameraShared);
    readonly delCam$ = this.store.select((state: AppState) => state.camera.deleteCam);
    readonly mosaics$ = this.store.select((state: AppState) => state.camera.mosaics);
    readonly userMosaics$ = this.store.select((state: AppState) => state.camera.userMosaics);
    readonly success$ = this.store.select((state: AppState) => state.camera.success);
    readonly delStatus$ = this.store.select((state: AppState) => state.camera.deleteStatus);
    readonly groupCamera$ = this.store.select((state: AppState) => state.camera.groupCamera);
    readonly groupList$ = this.store.select((state: AppState) => state.camera.groupCamera);
    readonly groupCameraID$ = this.store.select((state: AppState) => state.camera.groupCameraID);
    readonly clients$ = this.store.select((state: AppState) => state.camera.clientsGroup);
    readonly currentMosaic$ = this.store.select((state: AppState) => state.camera.currentMosaic);
    readonly successMosaic$ = this.store.select((state: AppState) => state.camera.success);
    readonly userInventory$ = this.store.select((state: AppState) => state.Users.userInventory);
    private readonly FREEZE_STREAM_TIME = 300000;

    @ViewChildren('video') queryVideos: QueryList<ElementRef>;

    noGroupCameras = false;


    mosaicFake = false;
    mosaicMenu = new UntypedFormControl('');
    maxMosaics = 4;

    waiting: boolean;
    hasCameras: boolean;
    timestamp = new Date().getTime();

    modalClose: Subscription;
    camSub: Subscription;
    invSub: Subscription;
    groupCamSub: Subscription;
    querySub: Subscription;
    mosaicSub: Subscription;
    userMosaicSub: Subscription;
    currentMosaicSub: Subscription;
    cameraSub: Subscription;
    currentSub: Subscription;
    successSub: Subscription;
    clientSub: Subscription;
    groupSub: Subscription;
    groupListSub: Subscription;
    deleteCam: Subscription;
    updateCam: Subscription;
    menu: Subscription;
    getTypesAnalytic: Subscription;
    returnSwal: Subscription;
    delMosaic: Subscription;
    userInventorySub: Subscription;

    typesAnalytic: AnalyticTypes[] = null;
    opState: OperationStatus;
    freezeTimeoutUnsub: NodeJS.Timeout;

    cameras: Camera[] = [];
    copyCameras: Camera[] = [];
    camerasShared: Camera[] = [];

    mosaicTemplate: Mosaic[] = [];
    userMosaics: Mosaic[] = [];
    currentMosaic: Mosaic;

    statusMosaic: boolean[];
    elem: any[] = [];
    videos: HTMLVideoElement[] = [];
    videoRef: ElementRef[];
    hlsInstances: Hls[] = [];
    watch_time_videos: {
        start: number;
        id_camera: number;
        id_plan: number;
    }[] = [];
    loading = false;

    scrollbarCameras: any;
    scrollbarShared: any;

    selectedVideo = -1;
    collapsed = false;
    statusCam = true;
    mqSmall: MediaQueryList;
    inventories: UserInventory;

    userSub: string;
    idCam: number;
    confirm: any;
    sizeChanges: number;
    informationMenu: string[];
    associate_id = environment.associateId;
    camerasOnMosaic: CameraId[];

    saveCameras = false;
    isFullscreen = false;
    activeList = [];
    isFirstMount = false;

    firstCam: string;
    firstAccess = true;

    timeOutHandler: ReturnType<typeof setTimeout>;

    firstGrid = true;
    choosingMosaic = false;
    pageName = 'camera-view';

    isDropdownActive = false;
    isLayoutDropdownActive = false;
    loadingClients = false;
    isPartner: boolean;
    isGuest = false;
    isClientAssociate: boolean = localStorage.getItem('profile_name') === '419bea06-5d4e-4a56-b8b5-04b3ad566d59';
    adminClientAssociate: boolean;
    isPartnerAssociate: boolean = localStorage.getItem('profile_name') === 'f29868c7-b4c5-4963-9ae8-1dd95699d6c3';
    adminPartnerAssociate: boolean;

    clientListSimple: {
        id: number | string;
        text: string;
        client_sub: string;
    }[];
    selectedClient: string;
    loadingCamera: boolean;
    loadingScroll: boolean;
    associate: Associate;

    ownerName: string;
    hasGroups: boolean;
    groupListSimple: {
        id: number;
        text: string;
    }[];
    loadingGroup: boolean;
    initMosaic: boolean;
    selectedGroup: number;
    currentMosaicIndex: number;
    timeStatus: number;

    sum = 1;
    sumGroup = 1;
    camLimit = 9;

    actual: number;
    actualGroup: number;
    allPages = 0;
    allPagesGroup = 0;
    totalAmount = 0;
    totalAmountGroup = 0;
    actualAmount: number;
    actualAmountGroup: number;

    freezeStreaming: boolean[] = new Array(50).map(x => false);
    cameraRemoved: boolean[] = new Array(50).map(x => false);

    searchInputControl = new UntypedFormControl('', []);

    private destroy$ = new Subject<void>();
    newMosaicCreated = false;
    mosaicDeleted = false;
    idMosaicToEdit: number;

    partnerSub = localStorage.getItem('partnerSub');
    is_partner_client = localStorage.getItem('profile_name') == '61902d2b-3ada-49f3-b42a-1775bc064bb0';

    constructor(private service: CameraService, private router: Router, private validationResponse: ValidationResponseHandlerModule,
        private sanitizer: DomSanitizer, private readonly store: Store<AppState>, private sharedService: SharedService,
        private cameraData: ShareDataService, private IS: ImageService) {
    }

    ngOnInit() {
        this.timeStatus = 15;
        this.initMosaic = true;
        this.loadingCamera = false;
        this.mqSmall = window.matchMedia('(max-width: 599px');
        this.waiting = true;
        this.loadingGroup = true;
        this.hasCameras = true;
        const sub = localStorage.getItem('sub');
        this.associate = JSON.parse(localStorage.getItem('associate'));
        this.firstCam = localStorage.getItem('firstMosaicCamera');
        this.userSub = sub;
        this.getProfile();
        if (this.isPartner || this.isPartnerAssociate) {
            this.getClients();
        }
        // this.store.dispatch(this.userActions.get_configurations_alarm({ user_sub: this.userSub }));
        // this.getActiveAnalytic();
        this.store.dispatch(CameraActions.get_group_cameras({
            user_sub: this.userSub,
            type_request: 'list',
            active: true
        }));
        this.loadCameras();
        this.store.dispatch(CameraActions.get_mosaics()); //mosaic_template
        this.store.dispatch(CameraActions.get_user_mosaics({ user_sub: sub }));
        this.getCamerasToMosaic();

        document.addEventListener('fullscreenchange', this.changeFullscreen.bind(this));

        this.updateCameraEdit();
        this.confirmUpdateCamera();
        this.confirmDeleteFeedback();
        this.deleteMosaicResponse();
        this.getgroupCameraList();
        this.selectGroupResult();
        this.userInventoryClient();

        //cameras: Camera[] = [];
        // Recebe o retorno das informações do swal

        this.returnSwal = this.sharedService.swalDecision.subscribe(returnSwallObject => {
            if (returnSwallObject) {
                this.validateReturnMethodCalled(returnSwallObject as ResultAlert);
            }
        });
        //thread para sempre deixar o mosaico no display limpo, sem interferências assíncronas em mudanças de mosaico
        //Tempo de espera para não quebrar quando abrir mosaico ao carregar uma câmera da lista de câmeras
    }

    // Handle window close or tab change
    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event) {
        // event.preventDefault();
        this.watch_time_videos.forEach((element, i) => {
            if (element) {
                const playDuration = (Date.now() - element.start) / 1000;
                this.logVideoWatchTime(playDuration, element.id_camera, element.id_plan);
            }
            this.watch_time_videos[i] = null; // Reset the start time
        });
    }

    private handleUserMosaics(userMosaics: any[]): void {

        if (!userMosaics) {
            this.userMosaics = [];
            return;
        }

        this.userMosaics = userMosaics;

        if (this.newMosaicCreated) {
            this.newMosaicCreated = false;
            this.changeMosaic(userMosaics[0]);
        }

        if (this.mosaicDeleted) {
            this.mosaicDeleted = false;
            const currentPlayingMosaic = userMosaics.find(mosaic => mosaic.id === this.currentMosaic.id);
            if (this.currentMosaic?.name && !currentPlayingMosaic) {
                this.clearMosaic(this.currentMosaic);
                this.currentMosaic.name = null;
            }
        }

        if (this.currentMosaic?.name && !this.newMosaicCreated) {
            const mosaicApi = userMosaics.find(mosaic => mosaic.id === this.currentMosaic.id);
            if (!this.compareMosaics(mosaicApi, this.currentMosaic)) {
                this.changeMosaic(mosaicApi);
            }
        }

        this.loadingCamera = false;
        this.loadingScroll = false;
    }

    getCamerasToMosaic() {
        this.isFirstMount = true;
        this.camSub = this.cameras$.subscribe(cameras => {
            this.loadingCamera = false;
            this.loadingGroup = false;
            this.loadingScroll = false;
            if (cameras && cameras.model === 'cameras') {
                const cams = cameras.cameras as PaginationCameras;
                this.totalAmount = cams.total;
                this.allPages = cams.pages;
                this.actual = cams.actual;
                this.camLimit = cams.limit;

                this.currentMosaic?.cameras?.forEach(c => {
                    cams.cameras?.forEach(cam => {
                        if (cam.id_camera === c.id_camera) {
                            const index = this.currentMosaic?.cameras?.indexOf(c);
                            if (index >= 0) {
                                this.videos[index].playbackRate = 0;
                                this.hlsInstances[index].detachMedia(); // Libera a mídia antes de atualizar a URL
                                this.hlsInstances[index].loadSource(cam.url_view);
                                this.hlsInstances[index].attachMedia(this.videos[index]);
                                this.restartStreamings(false);
                            }
                        }
                    });
                });
                this.waiting = false;
                // Câmeras do usuário
                this.getUniqueCameras(cams.cameras);
            }
            this.hasCameras = this.cameras.length > 0 || this.camerasShared.length > 0;
        });

        this.invSub = this.camerasShared$.subscribe(shareCams => {
            this.loadingCamera = false;
            this.loadingScroll = false;
            if (shareCams) {
                if (shareCams.length >= 0) {
                    //  Câmeras Compartilhadas
                    this.camerasShared = shareCams.filter(function (elem) {
                        return elem.active != false;
                    });
                    this.hasCameras = this.hasCameras = this.cameras.length > 0 || this.camerasShared.length > 0;
                    this.camerasShared.forEach(async c => {
                        this.IS.saveCacheThumbs(c.thumbnail);
                        c.cache_thumb = of(
                            await this.IS.getCSSBackgroundImageURL(c.thumbnail)
                        );
                    });
                } else {
                    this.camerasShared = [];
                }
            }
        });

        this.groupCamSub = this.groupCamera$.subscribe(groupCamera => {
            this.loadingGroup = false;
            this.loadingScroll = false;
            if (groupCamera && 'cameras' in groupCamera && groupCamera.cameras) {
                if (groupCamera.cameras.length > 0) {
                    this.totalAmountGroup = groupCamera.total;
                    this.allPagesGroup = groupCamera.pages;
                    this.actualGroup = groupCamera.actual;
                    this.actualAmountGroup = this.actualGroup < this.allPagesGroup ? this.camLimit * this.actualGroup : this.totalAmountGroup;
                    this.getUniqueCameras(groupCamera.cameras, true);
                    this.noGroupCameras = false; // Grupo com câmeras, não mostra o feedback
                } else {
                    this.noGroupCameras = true; // Grupo sem câmeras, mostra o feedback
                }
            } else {
                this.noGroupCameras = true; // Grupo não encontrado ou sem câmeras, mostra o feedback
            }


            this.hasCameras = this.cameras.length > 0 || this.camerasShared.length > 0;
        });

        this.mosaics$.pipe(
            filter(mosaic => mosaic !== null && mosaic !== undefined),
            take(1), // Ensure mosaics$ runs only once
            tap(mosaic => {
                this.mosaicTemplate = mosaic;

                if (this.isFirstMount) {
                    this.currentMosaic = {
                        cameras: [],
                        fixed: false,
                        id: 0,
                        id_mosaic_template: 2,
                        name: null,
                        height: 2,
                        width: 2
                    };
                    this.createGrid();
                    this.isFirstMount = false;
                }
            }),
            switchMap(() => this.userMosaics$.pipe(filter(userMosaics => userMosaics !== null && userMosaics !== undefined)))
        ).subscribe(userMosaics => this.handleUserMosaics(userMosaics));

        this.successMosaic$.pipe(
            filter(success => success !== null && success !== undefined))
            .subscribe((success) => {
                this.newMosaicCreated = true;
            });

    }

    updateNoGroupCamerasFlag() {
        if (this.groupListSimple && this.groupListSimple.length > 0) {

            this.noGroupCameras = false;
        } else {
            this.noGroupCameras = true;
        }
    }


    getgroupCameraList() {
        this.groupListSub = this.groupList$.subscribe(data => {
            if (data && !('cameras' in data)) {
                this.groupListSimple = data.map(c => {
                    return {
                        id: c.id_camera_group,
                        text: c.alias
                    };
                });
                this.hasGroups = this.groupListSimple.length > 0;
                this.loadingGroup = false;
            }
        });
    }

    defineMenuCam(byGroup: boolean) {
        if (this.isPartner || this.isPartnerAssociate) {
            return ['Adicionar analítico', 'Convidar', 'Recuperar vídeos', 'Configurações'];
        }
        else if (this.isClientAssociate && !this.adminClientAssociate) {
            return  ['Recuperar vídeos', 'Ver todos os alertas'];
        }
        else if (this.isClientAssociate && this.adminClientAssociate) {
            if (byGroup) {
                return ['Recuperar vídeos', 'Ver todos os alertas'];
            } else {
                return ['Adicionar analítico', 'Convidar', 'Recuperar vídeos', 'Ver todos os alertas', 'Configurações'];
            }
        } else {
            return ['Adicionar analítico', 'Convidar', 'Recuperar vídeos', 'Ver todos os alertas', 'Configurações'];
        }
    }

    getUniqueCameras(cameras: Camera[], byGroup = false): Camera[] {
        if (cameras) {
            const idOrdainedList = cameras.sort((a, b) => {
                return a.id - b.id;
            });

            idOrdainedList.forEach(async (current, index, list) => {
                if (current && current.active) {
                    if (this.cameras.length >= 0) {
                        const camExist = this.cameras.find(x => x.id === current.id || x.hashname === current.hashname);
                        if (!camExist) {
                            current.isFromGroup = byGroup;
                            current.informationMenu = this.defineMenuCam(byGroup);
                            this.addThumbInCache(current);
                            this.cameras.push(current);
                        } else {
                            this.updateThumbInCache(camExist);
                        }
                    } else {
                        this.addThumbInCache(current);
                        this.cameras.push(current);
                    }
                }
            });
            return this.cameras;
        }
        return [];
    }

    async addThumbInCache(c: Camera) {
        this.IS.saveCacheThumbs(c.thumbnail);
        c.cache_thumb = of(await this.IS.getCSSBackgroundImageURL(c.thumbnail));
    }

    async updateThumbInCache(c: Camera) {
        await this.IS.deleteCacheThumb(c.thumbnail);
        await this.addThumbInCache(c);
    }

    brokenImageHandler(element) {
        element.error = false;
        element.target.src = '../../../assets/img/broken_link.svg';
    }

    getProfile() {
        const profile = localStorage.getItem('profile_name');
        this.isPartner = (profile == 'cd343bfc-17e8-11ec-9621-0242ac130002');
        this.isGuest = (profile == '419bea06-5d4e-4a56-b8b5-04b3ad566d59');
        this.adminClientAssociate = this.isClientAssociate && localStorage.getItem('associate_permission') === 'e816c560-812e-11ed-a1eb-0242ac120002';
        this.adminPartnerAssociate = this.isPartnerAssociate && localStorage.getItem('associate_permission') === 'e816c560-812e-11ed-a1eb-0242ac120002';
    }

    getClients() {
        this.loadingClients = true;
        this.clientSub = this.clients$.subscribe(data => {
            if (data) {
                this.clientListSimple = data.map(e => {
                    return {
                        id: e.client_id,
                        text: e.client_name,
                        client_sub: e.client_sub
                    };
                });
                this.loadingClients = false;
            } else {
                this.store.dispatch(CameraActions.get_clients_group({
                    user_sub: this.userSub
                }));
            }
        });
    }

    selectClient(id) {
        const query = this.searchInputControl.value;
        this.loadingCamera = true;
        this.loadingGroup = true;
        this.initCameras();
        if (id) {
            const item = this.clientListSimple.find(element => element.id == id);
            this.selectedClient = item ? item.client_sub : undefined;
            if (!this.isPartner && !this.isPartnerAssociate) {
                this.store.dispatch(CameraActions.get_group_cameras({
                    user_sub: this.userSub,
                    child_sub: this.selectedClient,
                    type_request: this.selectedGroup > 0 ? 'data' : 'cameras',
                    page: this.sumGroup,
                    group_id: this.selectedGroup,
                    limit: this.camLimit,
                    str_filter: query,
                    active: true
                }));
            }
            this.store.dispatch(CameraActions.get_cameras({
                user_sub: this.userSub,
                child_sub: this.selectedClient,
                group_id: this.selectedGroup,
                page: this.sum,
                limit: this.camLimit,
                str_filter: query,
                short: false,
                active: true
            }));
        } else {
            this.selectedClient = null;
            this.loadCameras();
        }
    }

    selectGroup(id) {
        this.copyCameras = this.cameras;
        const query = this.searchInputControl.value;
        this.loadingGroup = true;
        this.initCameras();
        if (id.length > 0) {
            this.selectedGroup = id[0];
            this.store.dispatch(CameraActions.get_group_cameras({
                user_sub: localStorage.getItem('sub'),
                type_request: 'data',
                child_sub: this.selectedClient,
                group_id: this.selectedGroup,
                page: this.sumGroup,
                limit: this.camLimit,
                str_filter: query,
                active: true
            }));
        } else {
            this.selectedGroup = null;
            this.loadCameras();
        }
    }

    selectGroupResult() {
        this.groupSub = this.groupCameraID$.subscribe(result => {
            if (result && result.length > 0 && this.selectedGroup) {
                const pagCams = result[0].cameras_info_group;
                this.totalAmountGroup = pagCams.total;
                this.allPagesGroup = pagCams.pages;
                this.actualGroup = pagCams.actual;
                this.actualAmountGroup = this.actualGroup < this.allPagesGroup ? this.camLimit * this.actualGroup : this.totalAmountGroup;
                this.getUniqueCameras(pagCams.cameras, true);
            }
            else {
                this.cameras = [];
            }
            this.loadingGroup = false;
        });
    }

    toAddCamera() {
        this.router.navigateByUrl('/cameras/cadastro');
    }

    ngAfterViewInit() {
        this.querySub = this.queryVideos.changes.subscribe(r => {
            if (this.elem.length > 0 && this.initMosaic) {
                this.hlsInstances = [];
                this.videos = [];
                this.videoRef = [];
                this.videoRef = this.queryVideos.toArray();
                this.elem.forEach((value, index) => {
                    const video = this.videoRef[index] ? this.videoRef[index].nativeElement as HTMLVideoElement : null;
                    //Override de css no elemento de vídeo
                    if (video) {
                        video.style.pointerEvents = 'none';
                        video.style.height = '100%';
                        video.style.width = '100%';
                        this.videos.push(video);
                        this.hlsInstances.push(new Hls());
                    }
                });
                this.initPlayer();
                this.initMosaic = false;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.camSub) {
            this.camSub.unsubscribe();
        }
        if (this.invSub) {
            this.invSub.unsubscribe();
        }
        if (this.querySub) {
            this.querySub.unsubscribe();
        }
        if (this.mosaicSub) {
            this.mosaicSub.unsubscribe();
        }
        if (this.userMosaicSub) {
            this.userMosaicSub.unsubscribe();
        }
        if (this.successSub) {
            this.successSub.unsubscribe();
        }
        if (this.cameraSub) {
            this.cameraSub.unsubscribe();
        }
        if (this.menu) {
            this.menu.unsubscribe();
        }
        if (this.modalClose) {
            this.modalClose.unsubscribe();
        }
        if (this.updateCam) {
            this.updateCam.unsubscribe();
        }
        if (this.deleteCam) {
            this.deleteCam.unsubscribe();
        }
        if (this.returnSwal) {
            this.returnSwal.unsubscribe();
        }
        if (this.getTypesAnalytic) {
            this.getTypesAnalytic.unsubscribe();
        }
        if (this.clientSub) {
            this.clientSub.unsubscribe();
        }
        if (this.groupSub) {
            this.groupSub.unsubscribe();
        }
        if (this.groupListSub) {
            this.groupListSub.unsubscribe();
        }
        if (this.delMosaic) {
            this.delMosaic.unsubscribe();
        }
        if (this.userInventorySub) {
            this.userInventorySub.unsubscribe();
        }
        if (this.currentMosaicSub) {
            this.currentMosaicSub.unsubscribe();
        }
        this.destroy$.next();
        this.videoTimers.forEach(timer => {
            if (timer) {
                clearTimeout(timer);
            }
        });
        this.destroy$.complete();
        // this.queryVideos.destroy();
        this.stopVideos();
        this.currentMosaic = null;
        document.removeEventListener('fullscreenchange', this.changeFullscreen.bind(this));
        this.store.dispatch(CameraActions.cleanup());
        // this.store.dispatch(UserActions.cleanup());
        this.store.dispatch(CameraActions.reset_return());
        localStorage.removeItem('idCameraChoice');

        if (this.freezeTimeoutUnsub) {
            clearTimeout(this.freezeTimeoutUnsub);
        }
        document.addEventListener('visibilitychange', null);
    // location.reload();
    }
    // Valida o carregamento da tela
    loadingEvent(event: boolean) {
        this.waiting = event;
    }

    loadCameras() {
        const query = this.searchInputControl.value;
        const sub = localStorage.getItem('sub');
        this.loadingCamera = true;
        this.initCameras();
        this.store.dispatch(CameraActions.get_cameras({
            user_sub: this.userSub,
            child_sub: this.selectedClient,
            page: this.sum,
            limit: this.camLimit,
            group_id: this.selectedGroup,
            str_filter: query,
            short: false,
            active: true
        }));
        if (!this.isPartner && !this.isPartnerAssociate) {
            this.store.dispatch(CameraActions.get_group_cameras({
                user_sub: this.userSub,
                child_sub: this.selectedClient,
                type_request: this.selectedGroup > 0 ? 'data' : 'cameras',
                page: this.sumGroup,
                limit: this.camLimit,
                group_id: this.selectedGroup,
                str_filter: query,
                active: true
            }));
        }
        this.store.dispatch(CameraActions.get_invited_cameras({
            user_sub: sub,
            list_type: ListType.Live
        }));
        this.loadingGroup = true;
    }

    loadPresetMosaic(userMosaics: Mosaic[], mosaic: Mosaic[]) {
        if (this.firstGrid) {
            this.currentMosaic = {
                cameras: [],
                fixed: false,
                id: 0,
                id_mosaic_template: 2,
                name: null,
                height: 2,
                width: 2
            };
        }
        if (mosaic.length > 0 && this.currentMosaic && this.firstGrid) {
            this.createGrid();
            this.firstGrid = false;
        }
        if (this.currentMosaic && userMosaics[0].id != this.currentMosaic.id) {
            this.userMosaics = userMosaics;
            // this.changeMosaic(userMosaics[0]);
        }
    }

    createMosaicFake(userMosaics: Mosaic[]) {
        if (this.mosaicTemplate.length != 0) {
            const oldUserMosaics = this.userMosaics;
            this.mosaicFake = true;
            this.currentMosaic = {
                cameras: [],
                fixed: false,
                id: 0,
                id_mosaic_template: 2,
                name: null,
                height: 2,
                width: 2
            };
            if (this.mosaicTemplate.length > 0 && this.currentMosaic) {
                this.createGrid();
            }
            // Limpa a lista de mosaicos do usuário, definindo que o mesmo não possui mosaicos pré-criados alem do default
            const indiceFake = userMosaics.find(element => element.name == null);
            if (indiceFake && this.userMosaics.length == 1) {
                this.userMosaics.splice(this.userMosaics.indexOf(indiceFake), 1);
            }

            if (this.userMosaics) {
                this.userMosaics = userMosaics;
                if ((oldUserMosaics.length + 1) == userMosaics.length) {
                    this.changeMosaic(userMosaics[userMosaics.length - 1]);
                }
            }
        } else {
            this.store.dispatch(CameraActions.get_mosaics());
        }

    }

    // Fecha as barras laterais de minhas câmeras e compartilhadas comigo
    collapseSidebar() {
        this.collapsed = !this.collapsed;
    }

    createGrid() {
        // Verificar se currentMosaic existe
        if (!this.currentMosaic) {
            this.currentMosaic = {
                cameras: [],
                fixed: false,
                id: 0,
                id_mosaic_template: 2, // ou um valor padrão
                name: null,
                height: 2,
                width: 2
            };
        }

        // Inicializar cameras se não existir
        if (!this.currentMosaic.cameras) {
            this.currentMosaic.cameras = [];
        }

        const mosaic: Mosaic = this.mosaicTemplate.find(m => m.id_mosaic_template === this.currentMosaic?.id_mosaic_template);
        if (mosaic) {
            this.currentMosaic.height = mosaic.height;
            this.currentMosaic.width = mosaic.width;
            const oldSize = this.currentMosaic.cameras.length;
            this.elem = Array.apply(0, Array(mosaic.height * mosaic.width)).map(() => ({ 'loading': false }));
            this.statusMosaic = new Array(mosaic.height * mosaic.width);
            const newSize = mosaic.width * mosaic.height;

            if (newSize > oldSize) {
                for (let index = oldSize; index < newSize; index++) {
                    this.currentMosaic.cameras.push({ id_camera: -1 });
                }
            } else {
                this.currentMosaic.cameras = this.currentMosaic.cameras.slice(0, newSize);
            }

            if (!this.firstCam) {
                this.waiting = false;
            }
        }
    }
    //Limpa o mosaico de visualização.
    //Caso receba um mosaico de parâmetro, limpa todas as câmeras que não são desse mosaico
    clearMosaic(mosaic?: Mosaic) {
        this.currentMosaic.cameras.forEach((cam, i) => {
            if (mosaic) {
                const isCameraInMosaic = this.isCameraInMosaic(cam, mosaic);
                if (!isCameraInMosaic || cam.id_camera == -1) {
                    this.removeCamera(i);
                }
            } else if (cam.id_camera !== -1) {
                this.removeCamera(i);
            }
        });
    }

    changeMosaic(mosaic: Mosaic) {
        mosaic = this.userMosaics.length == 1 ? this.userMosaics[0] : mosaic;
        const isEqual = this.compareMosaics(mosaic, this.currentMosaic);
        if (!isEqual) {
            this.waiting = true;
            //condicional para não haver interferências entre 2 trocas de mosaico,
            //pois ele limpa o visualizador e pode haver inconsistências
            //caso tenha alguma troca sendo efetivada, será repetido a tentativa em 0,5s
            if (!this.choosingMosaic) {
                this.choosingMosaic = true;
                setTimeout(() => {
                    //limpando o mosaico atual antes de escolher o novo tamanho
                    this.clearMosaic();
                    setTimeout(() => {
                        if (mosaic.id != this.currentMosaic.id){
                            this.change(mosaic.id);
                        }
                        this.chooseMosaic(mosaic.id_mosaic_template);
                        this.currentMosaic.id = mosaic.id;
                        this.currentMosaic.name = mosaic.name;
                        this.waiting = false;
                        this.chooseMosaicCameras(mosaic);
                    }, 550);
                }, 500);
                //Caso o mosaico esteja sendo trocado, entrará em delay para realizar a nova troca
            }
        } else {
            if (isEqual) {
                this.clearMosaic();
                this.activeList = [];
                this.currentMosaic.name = null;
            }
            else {
                this.currentMosaic.id = null;
                this.currentMosaic.name = null;
                this.currentMosaic.cameras = [];
            }
        }
    }

    compareMosaics(mosaic_1: Mosaic, mosaic_2: Mosaic) {
        if (mosaic_1.id_mosaic_template != mosaic_2.id_mosaic_template) {
            return false;
        }

        if (mosaic_1.id !== mosaic_2.id || mosaic_1.name !== mosaic_2.name) {
            return false;
        }

        //check if all mosaic_1 cameras is in mosaic_2
        for (const camId of mosaic_1.cameras) {
            if (camId.id_camera != -1) {
                if (!this.isCameraInMosaic(camId, mosaic_2)) {
                    return false;
                }
            }
        }
        //check if all mosaic_2 cameras is in mosaic_1
        for (const camId of mosaic_2.cameras) {
            if (camId.id_camera != -1) {
                if (!this.isCameraInMosaic(camId, mosaic_1)) {
                    return false;
                }
            }
        }

        return true;

    }

    isCameraInMosaic(cams_id: CameraId, mosaic: Mosaic) {
        let isCameraInMosaic = false;
        for (const currentCamId of mosaic.cameras) {
            if (currentCamId.id_camera == cams_id.id_camera) {
                isCameraInMosaic = true;
            }
        }
        return isCameraInMosaic;
    }

    chooseMosaicCameras(mosaic: Mosaic) {
    //função para escolher todas as cameras de um dado mosaico
        const allcameras = this.cameras.concat(this.camerasShared);
        for (const camId of mosaic.cameras) {
            if (camId.id_camera != -1) {
                const camera = allcameras.find(cam => cam.id === camId.id_camera);
                this.chooseCam(camera ? camera : camId as Camera);
            }
        }
        this.choosingMosaic = false;
    }

    openCreateMosaic() {
        this.pauseVideos(this.currentMosaic);
        this.store.dispatch(CameraActions.open_modal_mosaic());
    }

    openEditMosaic(mosaic: Mosaic) {
        this.pauseVideos(this.currentMosaic);
        this.store.dispatch(CameraActions.open_edit_modal_mosaic({ payload: mosaic }));
    }

    deleteMosaic(mosaic: Mosaic) {
        this.store.dispatch(CameraActions.delete_mosaic({
            idMosaic: mosaic.id
        }));
        this.loading = true;
    }

    deleteMosaicResponse() {
        this.delMosaic = this.delStatus$.subscribe(feedback => {
            if (feedback) {
                this.loading = false;
                if (feedback.success) {
                    this.validationResponse.validationResponseHandler(200, this.pageName, 'delete-mosaico', 'cameras.deleteMosaic');
                    if (this.userMosaics.length == 1) {
                        this.currentMosaic.name = null;
                        this.currentMosaic.id = null;
                        this.toggleDropdown();
                        this.userMosaics.pop();
                    }
                    this.mosaicDeleted = true;
                    this.loadCameras();
                    // this.store.dispatch(CameraActions.get_mosaics());
                    this.store.dispatch(CameraActions.get_user_mosaics({ user_sub: this.userSub }));
                }
                else {
                    Swal.fire({
                        title: 'Erro',
                        icon: 'error',
                        timer: 5000,
                        text: feedback.message
                    });
                }
                // this.store.dispatch(this.actions.reset_return());
                // if (this.userMosaics.length == 1) {
                //   this.loading = false;
                //   location.reload();
                // }
            }
        });
    }

    getContainerWidth(cols: number): string {
        return `calc(100% / ${cols});`;
    }

    getHeight(cols: number): any {
        const fullScreenElement = document['fullscreenElement'];
        let style = '';
        if (fullScreenElement && fullScreenElement.id === 'videoGrid') {
            style = `calc(100vh/${cols})`;
        }
        else {
            if (this.mqSmall.matches) {
                style = `calc( (60vh - 140px)/${cols})`;
            }
            else {
                style = `calc( (100vh - 140px)/${cols})`;
            }
        }
        return this.sanitizer.bypassSecurityTrustStyle(style);
    }

    // chooseMosaic(type: number) {
    //     this.freezeStreaming = Array(50).fill(false);
    //     this.initMosaic = this.initMosaic != true ? true : this.initMosaic;
    //     if (this.mosaicTemplate) {
    //         if (this.mosaicTemplate.length != 0) {
    //             const newMosaic = this.mosaicTemplate.find(m => m.id_mosaic_template === type);
    //             this.currentMosaic.height = newMosaic.height;
    //             this.currentMosaic.width = newMosaic.width;
    //             this.currentMosaic.id_mosaic_template = newMosaic.id_mosaic_template;
    //             this.createGrid();
    //         } else {
    //             this.store.dispatch(CameraActions.get_mosaics());
    //         }
    //     } else {
    //         this.store.dispatch(CameraActions.get_mosaics());
    //     }
    // }

    chooseMosaic(type: number) {
        this.freezeStreaming = Array(50).fill(false);
        this.initMosaic = this.initMosaic != true ? true : this.initMosaic;

        // Adicionar verificação inicial
        if (!this.currentMosaic) {
            this.currentMosaic = {
                cameras: [],
                fixed: false,
                id: 0,
                id_mosaic_template: type,
                name: null,
                height: 2,
                width: 2
            };
        }

        if (this.mosaicTemplate?.length > 0) {
            const newMosaic = this.mosaicTemplate.find(m => m.id_mosaic_template === type);
            if (newMosaic) {
                this.currentMosaic = {...newMosaic};
                this.createGrid();
                this.startFreezeTimers();
            }
        } else {
            this.store.dispatch(CameraActions.get_mosaics());
        }
    }

    startFreezeTimers() {
        this.freezeStreaming.forEach((isFrozen, index) => {
            if (!this.cameraRemoved[index] && this.watch_time_videos[index]) {
                setTimeout(() => {
                    if (!isFrozen) {
                        this.freezeStreaming[index] = true;
                        const watchData = this.watch_time_videos[index];
                        this.logVideoWatchTime(
                            5 * 60, // 5 minutos em segundos
                            watchData.id_camera,
                            watchData.id_plan
                        );
                    }
                }, this.FREEZE_STREAM_TIME);
            }
        });
    }


    waitGridToFocus() {
        if (document.getElementById('buttonGrid') == null) {

        } else {
            setTimeout(() => {
                document.getElementById('buttonGrid').focus();
            }, 100);
        }
    }

    chooseCam(camera: Camera, clicked?: boolean, replace?: number) {
        const index = replace === undefined ? this.findNextIndex() : replace;
        const camIndex = this.currentMosaic.cameras.findIndex(x => x.id_camera === camera.id);
        if (index < 0 && camIndex < 0) {
            if (!this.choosingMosaic) {
                this.validationResponse.validationResponseHandler(400, this.pageName, 'dimension-mosaic', 'cameras.dimension_mosaic');
            }
            return;
        }
        if (clicked) {
            this.change(null);
            this.currentMosaic.name = null;
            if (camIndex >= 0) {
                this.removeCamera(camIndex);
                return;
            } else {
                this.currentMosaic.cameras[index] = camera as CameraId;
                this.elem[index].loading = true;
                this.initPlayer(camera, index);
            }
        } else {
            this.currentMosaic.cameras[index] = camera as CameraId;
            this.elem[index].loading = true;
        }
    }

    findNextIndex(): number {
        return this.currentMosaic.cameras.findIndex(camera => camera.id_camera === -1);
    }

    removeCamera(index, clicked?: boolean) {
        if (document.getElementById('videos' + index) != null) {
            document.getElementById('videos' + index).removeAttribute('class');
            document.getElementById('play' + index).classList.remove('video_opacity');

            this.stopVideos(index);
            this.currentMosaic.cameras[index] = { id_camera: -1 };
            this.selectedVideo = -1;
            document.getElementById('videos' + index);
            if (clicked) {
                this.freezeStreaming[index] = false;
                this.cameraRemoved[index] = true;
                this.watch_time_videos[index] = null;
                this.videoTimers[index] = null;
                this.change(null);
                this.currentMosaic.name = null;
            }

            //removendo status de camera ativa
            const indicador = document.getElementById('indicador' + index);
            if (indicador) {
                indicador.removeAttribute('class');
            }

        } else {
            setTimeout(() => {
                this.removeCamera(index);
            }, 100);
        }

    }

    setInformationMenu(cam: Camera) {
        if (this.isPartner || this.isPartnerAssociate) {
            this.informationMenu = ['Adicionar analítico', 'Convidar', 'Recuperar vídeos', 'Configurações'];
        } else if (cam.owner === localStorage.getItem('wecloud-user-name')) {
            this.informationMenu = ['Adicionar analítico', 'Convidar', 'Ver gravações', 'Ver todos os alertas', 'Configurações'];
        } else if (cam.camera_group?.length > 0 || cam.isFromGroup) {
            this.informationMenu = ['Recuperar vídeos', 'Ver todos os alertas'];
        }

        if (Array.isArray(cam.integrated_camera)) {
            if (cam.integrated_camera.length > 0) {
                if (cam.integrated_camera[0] != null) {
                    if (this.informationMenu.includes('Adicionar analítico')) {
                        this.informationMenu.shift();
                    }
                }
            }
        } else if (cam.integrated_camera != null) {
            if (this.informationMenu.includes('Adicionar analítico')) {
                this.informationMenu.shift();
            }
        }
    }

    validatePermission(index){
        const camId = this.currentMosaic.cameras[index].id ? this.currentMosaic.cameras[index].id : this.currentMosaic.cameras[index].id_camera;
        const myCam = this.cameras ? this.cameras.find(camera => camera.id === camId) : this.currentMosaic.cameras[index] as Camera;
        const sharedCam = this.camerasShared ? this.camerasShared.find(camera => camera.id === camId) : null;
        if (sharedCam) {
            this.informationMenu = [];
            if (sharedCam['view_alert_history'] == true) {
                this.informationMenu.push('Ver todos os alertas');
            }
            if (sharedCam['view_recording'] == true) {
                this.informationMenu.push('Ver gravações');
            }
            if (sharedCam['active'] == true) {
                this.informationMenu.push('Excluir câmera');
            }
        } else if (myCam) {
            this.setInformationMenu(myCam);
        } else if (this.copyCameras.length > 0) {
            const cam = this.copyCameras ? this.copyCameras.find(camera => camera.id === camId) : this.currentMosaic.cameras[index] as Camera;
            this.setInformationMenu(cam);
            this.copyCameras = [];

        }
    }

    // Mêtodo usado para validar a exclusão de uma câmera de convidado
    deleteGuestCam(camerasShared: Camera) {
        this.validationResponse.validationResponseHandler(200, this.pageName, 'confirm-delete-guest-camera', 'cameras.delete_guest_camera');
    }

    async loadPlayer(camera: Camera, index: number) {
        this.freezeStreaming[index] = false;
        const hls = this.hlsInstances[index];
        const mosaicSize = localStorage.getItem('mosaicSize');

        // Limpa o timer anterior se existir
        if (this.videoTimers[index]) {
            clearTimeout(this.videoTimers[index]);
        }

        if (Hls.isSupported()) {
            const context = this;
            hls.loadSource(camera.url_view);
            hls.attachMedia(this.videos[index]);

            hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                console.log(`Manifest loaded, found ${data.levels.length} quality level(s).`);
                camera.status = true;
                this.watch_time_videos[index] = {
                    start: Date.now(),
                    id_camera: camera.id,
                    id_plan: camera.id_plan
                };

                // Inicia o timer de 5 minutos quando o manifest estiver pronto
                this.startFiveMinuteTimer(index, hls);
            });

            hls.on(Hls.Events.FRAG_LOADED, function (event, data) {
                if (camera.status === false) {
                    context.removeCamera(index);
                    hls.startLoad(-1);
                }
                context.cameraActive(index, camera);
                camera.status = true;
            });

            hls.on(Hls.Events.ERROR, function (event, data) {
                if (context.currentMosaic.cameras != null) {
                    if (context.currentMosaic.cameras[index].id_camera > 0) {
                        if (data.fatal) {
                            context.cameraInative(index, camera, mosaicSize);
                            context.hlsInstances[index].stopLoad();
                            context.hlsInstances[index].detachMedia();
                        } else {
                            switch (data.type) {
                                case Hls.ErrorTypes.NETWORK_ERROR:
                                    camera.status = false;
                                    context.cameraInative(index, camera, mosaicSize);
                                    hls.startLoad();
                                    break;
                                case Hls.ErrorTypes.MEDIA_ERROR:
                                    context.cameraInative(index, camera, mosaicSize);
                                    if (data.details === 'bufferStalledError') {
                                        hls.startLoad();
                                    } else {
                                        hls.recoverMediaError();
                                    }
                                    break;
                                default:
                                    hls.destroy();
                                    break;
                            }
                        }
                    }
                }
            });

            this.videos[index].addEventListener('loadedmetadata', () => {
                this.freezeStream(index, hls);
            });
        }
        else if (this.videos[index].canPlayType('application/vnd.apple.mpegurl')) {
            this.cameraActive(index, camera);
            this.videos[index].src = camera.url_view;

            this.videos[index].addEventListener('loadedmetadata', () => {
                this.playVideo(index);
                this.freezeStream(index, hls);

                // Inicia o timer de 5 minutos para Safari
                this.startFiveMinuteTimer(index, hls);
            });
        }

        let hiddenStartTime;
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                hiddenStartTime = Date.now();
                this.videos?.forEach(video => {
                    video.pause();
                });
            } else {
                const timeAway = (Date.now() - hiddenStartTime) / 1000;
                this.videos?.forEach(video => {
                    if (video.readyState >= 2 && video.paused && !video.ended) {
                        video.play().catch(e => console.warn('Play falhou:', e));
                    }
                });
                if (timeAway >= 300) {
                    this.videos[index].playbackRate = 0;
                    hls.stopLoad();
                    this.freezeStreaming[index] = true;
                }
            }
        });
    }

    // Novo método para gerenciar o timer de 5 minutos
    private startFiveMinuteTimer(index: number, hls: any) {
        // Limpa o timer anterior se existir
        if (this.videoTimers[index]) {
            clearTimeout(this.videoTimers[index]);
        }

        // Configura novo timer
        this.videoTimers[index] = window.setTimeout(() => {
            if (!this.freezeStreaming[index] && this.watch_time_videos[index]) {
                this.freezeStreaming[index] = true;
                const watchData = this.watch_time_videos[index];
                this.logVideoWatchTime(
                    5 * 60,
                    watchData.id_camera,
                    watchData.id_plan
                );

                // Pausa o vídeo quando o tempo expirar
                this.videos[index].pause();
                this.videos[index].playbackRate = 0;
                if (hls) {
                    hls.stopLoad();
                }
            }
        }, this.FREEZE_STREAM_TIME);
    }


    freezeStream(index: number, hls: Hls) {
        this.cameraRemoved[index] = false;
        this.freezeTimeoutUnsub = setTimeout(() => {
            if (!this.videos[index].currentSrc) {
                clearTimeout(this.freezeTimeoutUnsub);
                return;
            }
            this.videos[index].pause();
            this.videos[index].playbackRate = 0;
            hls.stopLoad();
            this.freezeStreaming[index] = true;
            const playDuration = (Date.now() - this.watch_time_videos[index].start) / 1000;
            this.logVideoWatchTime(playDuration, this.watch_time_videos[index].id_camera, this.watch_time_videos[index].id_plan);
        }, this.FREEZE_STREAM_TIME);
    }

    // Valida as classes visuais para quando a câmera for inativa
    cameraInative(index, cam: Camera, size) {
        if (this.videoTimers[index]) {
            clearTimeout(this.videoTimers[index]);
            this.videoTimers[index] = null;
        }
        setTimeout(() => {
            const videos = document.getElementById('videos' + index);
            const videoIndex = document.getElementById('play' + index);
            const indicator = document.getElementById('indicator' + index);
            const camerasLateras = document.getElementById(cam.id.toString());
            this.statusMosaic[index] = false;
            this.elem[index].loading = false;
            let endClasse = '';
            videoIndex.classList.add('video_opacity');
            if (indicator) {
                switch (size) {
                    case '1':
                        endClasse = 'span_content_1';
                        break;
                    case '2':
                        endClasse = 'span_content_2';
                        break;
                    case '3':
                        endClasse = 'span_content_3';
                        break;
                }
                videos.classList.add(endClasse);
                if (indicator.classList != null || indicator.classList === undefined || indicator.classList.length > 0) {
                    indicator.removeAttribute('class');
                }
                if (camerasLateras.classList != null || camerasLateras.classList === undefined || camerasLateras.classList.length > 0) {
                    camerasLateras.removeAttribute('class');
                }
                camerasLateras.classList.add('image_thumbnail');
                indicator.classList.add('nomeCam_statusCam', 'camera_status_false');
            }
        }, this.timeStatus * 1000);
    }

    // Valida as classes visuais para quando a câmera for ativa
    cameraActive(index, camera: Camera) {
        const videoIndex = document.getElementById('play' + index);
        const videos = document.getElementById('videos' + index);
        const indicator = document.getElementById('indicator' + index);
        const camerasLateras = document.getElementById(camera.id.toString());
        this.statusMosaic[index] = true;
        this.elem[index].loading = false;
        if (videoIndex != null && videos != null && indicator != null && camerasLateras != null) {
            if (camerasLateras.classList != null && camerasLateras.classList != undefined && camerasLateras.classList.length > 0) {
                camerasLateras.removeAttribute('class');
            }
            if (videos.classList != null && videos.classList != undefined && videos.classList.length > 0) {
                videos.removeAttribute('class');
            }
            if (indicator.classList != null && indicator.classList != undefined && indicator.classList.length > 0) {
                indicator.removeAttribute('class');
            }
            videoIndex.classList.remove('video_opacity');
            if (camera.id != -1) {
                indicator.classList.add('nomeCam_statusCam', 'camera_status_true');
            }

        }
    }

    callUserInventory() {
        this.store.dispatch(UserActions.get_user_inventory({
            user_sub: this.userSub,
            child_sub: localStorage.getItem('clientView'),
            partner_sub: this.partnerSub
        }));
    }

    userInventoryClient() {
        this.userInventorySub = this.userInventory$.subscribe(inventory => {
            if (inventory) {
                if (inventory.model === 'feedback') {
                    if (!this.is_partner_client) {
                        this.validationResponse.validationResponseHandler(403, 'user-summary', 'userinventory-error', 'user.userinventory_error', inventory.message);
                    }
                } else {
                    this.inventories = inventory[0];
                    localStorage.setItem('inventoryClientAvailable', String(this.inventories.inventory.ai.available));
                }
            }
        });
    }

    // Valida as opções no menu de cada camera do mosaico
    managingCameras(menuInfor, index: number) {
        const camId = this.currentMosaic.cameras[index].id ? this.currentMosaic.cameras[index].id : this.currentMosaic.cameras[index].id_camera;
        this.idCam = camId;
        let myCams = this.cameras ? this.cameras.find(camera => camera.id === camId) : this.currentMosaic.cameras[index] as Camera;
        myCams = myCams ? myCams : this.currentMosaic.cameras[index] as Camera;
        const sharedCams = this.camerasShared ? this.camerasShared.find(camera => camera.id === camId) : null;
        this.saveCameras = true;

        switch (menuInfor) {
            // Abre o modal de adiciona um novo analítico
            case 'Adicionar analítico':
                if (this.isPartner || this.isPartnerAssociate) {
                    localStorage.setItem('clientView', myCams.sub);
                    this.callUserInventory();
                }
                this.goToAnalyticsPage(myCams);
                break;
                // Abre o modal de convidar novos usuários para a câmera
            case 'Convidar':
                if (myCams) {
                    if (this.isPartner || this.isPartnerAssociate) {
                        localStorage.setItem('clientView', myCams.sub);
                        this.callUserInventory();
                    }
                    this.openModalInviteUser(myCams);
                }
                break;
                // Abre a tela de Gravações das câmeras
            case 'Recuperar vídeos':
                if (camId) {
                    localStorage.setItem('idCameraChoice', String(camId));
                    this.router.navigateByUrl('/cameras/retrieve');
                }
                break;
                // Abre a tela de Gravações das câmeras de um convidado
            case 'Ver gravações':
                if (camId) {
                    localStorage.setItem('idCameraChoice', String(camId));
                    this.router.navigateByUrl('/cameras/retrieve');
                }
                break;
                // Abre a tela de relatório de alertas
            case 'Ver todos os alertas':
                if (camId) {
                    localStorage.setItem('idCameraChoice', String(camId));
                    this.router.navigateByUrl('/cameras/alert');
                }
                break;
                // Abre o modal de configurações da câmera apenas se a câmera for do usuario
            case 'Configurações':
                if (myCams) {
                    this.openModalCameraUpdate(myCams);
                }
                break;
                // Deleta a câmera de um convidado
            case 'Excluir câmera':
                if (sharedCams) {
                    this.currentMosaicIndex = index;
                    this.deleteGuestCam(sharedCams);
                }
                break;
        }
    }

    // Retorna a classe do status da camera para o retorno do banco
    getClassCamera(index: number, status, size): string {
        localStorage.setItem('mosaicSize', String(size));
        if (this.currentMosaic.cameras.length != 0 && (this.currentMosaic.cameras[index] != undefined || this.currentMosaic.cameras[index].id_camera != -1)) {
            const camId = this.currentMosaic.cameras[index].id_camera;
            let endClasse = '';
            let camIndice = this.cameras ? this.cameras.find(camera => camera.id === camId) : null;
            if (camIndice && this.currentMosaic.cameras[index].hashname) {
                camIndice = camIndice ? camIndice : this.currentMosaic.cameras[index] as Camera;
                if (camIndice.status === false || status === false) {
                    switch (size) {
                        case '1':
                            endClasse = 'span_content_1';
                            break;
                        case '2':
                            endClasse = 'span_content_2';
                            break;
                        case '3':
                            endClasse = 'span_content_3';
                            break;
                    }
                    return endClasse;
                } else {
                    return '';
                }
            } else {
                camIndice = this.camerasShared ? this.camerasShared.find(camera => camera.id === camId) : null;
                if (camIndice) {
                    if (camIndice.status === false || status === false) {
                        switch (size) {
                            case '1':
                                endClasse = 'span_content_1';
                                break;

                            case '2':
                                endClasse = 'span_content_2';
                                break;

                            case '3':
                                endClasse = 'span_content_3';
                                break;
                        }
                        return endClasse;
                    }
                    else {
                        return '';
                    }
                }
            }
        }
        else {
            return '';
        }
    }

    initPlayer(cam?: Camera, index?: number): void {
        this.statusCam = true;
        if (cam) {
            let camera = this.cameras.find(c => c.id === cam.id);
            if (!camera) {
                camera = this.camerasShared.find(c => c.id === cam.id);
            }
            this.loadPlayer(camera ? camera : cam, index);
        }
        else {
            if (this.currentMosaic) {
                this.currentMosaic.cameras.forEach((cameraId, i) => {
                    if (cameraId.id_camera != -1) {
                        let camera = this.cameras.find(c => c.id === cameraId.id_camera);
                        if (!camera) {
                            camera = this.camerasShared.find(c => c.id === cameraId.id_camera);
                        }
                        // Create a Player instance.
                        //Solução alternativa para override de css do Mat-Video
                        camera = camera ? camera : cameraId as Camera;
                        this.loadPlayer(camera, i);
                    }
                });
            }
        }
    }


    private videoTimers: number[] = Array(50).fill(0);

    playVideo(index: number) {
        const hls = this.hlsInstances[index];

        this.videos[index].play();
        this.videos[index].playbackRate = 1;
        hls.startLoad();
        this.freezeStreaming[index] = false;
        this.freezeStream(index, hls);


        if (this.videoTimers[index]) {
            clearTimeout(this.videoTimers[index]);
        }

        this.videoTimers[index] = window.setTimeout(() => {
            if (!this.freezeStreaming[index] && this.watch_time_videos[index]) {
                this.freezeStreaming[index] = true;
                const watchData = this.watch_time_videos[index];
                this.logVideoWatchTime(
                    5 * 60,
                    watchData.id_camera,
                    watchData.id_plan
                );

                this.videos[index].pause();
                this.videos[index].playbackRate = 0;
                hls.stopLoad();
            }
        }, this.FREEZE_STREAM_TIME);
    }

    // playVideo(index: number) {
    //     const hls = this.hlsInstances[index];
    //     this.videos[index].play();
    //     this.videos[index].playbackRate = 1;
    //     hls.startLoad();
    //     this.freezeStreaming[index] = false;
    //     this.freezeStream(index, hls);
    // }

    openFullscreen(value) {
        const idMosaico = document.getElementById(value);
        if (!this.isFullscreen && idMosaico.requestFullscreen) {
            idMosaico.requestFullscreen();
        }
    }

    changeFullscreen() {
        this.isFullscreen = this.isFullscreen ? false : true;
    }

    isMosaicEmpty(): boolean {
        return this.currentMosaic.cameras.map(function (value) {
            return value.id_camera < 0;
        }).reduce(function (curr, prev) {
            return curr && prev;
        });
    }

    saveMosaic() {
        this.loading = true;
        this.store.dispatch(CameraActions.save_mosaic({ mosaic: this.currentMosaic, idMosaic: this.currentMosaic.id }));
        this.successSub = this.success$.subscribe(success => {
            if (success) {
                this.validationResponse.validationResponseHandler(200, this.pageName, 'save-mosaic', 'cameras.save_mosaic');
            }
        });
    }

    validateReturnMethodCalled(returnResultSwal: ResultAlert) {
        if (returnResultSwal.methodCalled === 'saveMosaic') {
            if (returnResultSwal.isConfirmed) {
                this.loading = false;
            }
            else if (returnResultSwal.isDismissed) {
            }
        } else if (returnResultSwal.methodCalled === 'deleteGuestCam') {
            if (returnResultSwal.isConfirmed) {
                this.service.closeModals(true);
                this.store.dispatch(CameraActions.delete_guest_camera({ user_sub: this.userSub, camera_id: this.idCam }));
            } else if (returnResultSwal.isDismissed) {
            }
        } else if (returnResultSwal.methodCalled === 'deleteCam') {
            if (returnResultSwal.isConfirmed) {
                this.loading = true;
                this.service.closeModals(true);
                this.store.dispatch(CameraActions.delete_camera({ camera_id: this.idCam, child_sub: localStorage.getItem('clientView') }));
            } else if (returnResultSwal.isDismissed) {
            }
        } else if (returnResultSwal.methodCalled === 'deleteCam') {
            if (returnResultSwal.isConfirmed) {
                this.loading = true;
                this.service.closeModals(true);
                this.store.dispatch(CameraActions.delete_camera({ camera_id: this.idCam, child_sub: localStorage.getItem('clientView') }));
            } else if (returnResultSwal.isDismissed) {
            }
        }
    }

    destroyVideo(index) {
        if (this.freezeTimeoutUnsub) {
            clearTimeout(this.freezeTimeoutUnsub);
        }
        document.removeEventListener('visibilitychange', null);
        this.watch_time_videos.forEach((element, i) => {
            if (element) {
                const playDuration = (Date.now() - element.start) / 1000;
                this.logVideoWatchTime(playDuration, element.id_camera, element.id_plan);
            }
            this.watch_time_videos[i] = null; // Reset the start time

        });
        if (this.hlsInstances[index]) {
            this.hlsInstances[index].stopLoad();
            this.hlsInstances[index].detachMedia();
            this.hlsInstances[index].destroy();
            this.hlsInstances[index] = new Hls();
        }
        if (this.videos[index]) {
            this.videos[index].pause();
            this.videos[index].currentTime = 0;
            this.videos[index].src = '';
            // this.videos[index].remove();
            // this.videos[index].load();
        }
    }

    pauseVideos(mosaic: Mosaic) {
        if (mosaic) {
            mosaic.cameras.forEach((cameraId, i) => {
                if (this.videos && this.videos[i]) {
                    this.videos[i].pause();
                }
                else if (this.hlsInstances && this.hlsInstances[i]) {
                    this.hlsInstances[i].stopLoad();
                    // this.hlsInstances[i].detachMedia();
                    this.hlsInstances[i] = new Hls();
                }
            });
        }
    }

    stopVideos(index?: number, mosaic?: Mosaic) {
        if (index >= 0) {
            this.destroyVideo(index);
        } else {
            if (mosaic) {
                mosaic.cameras.forEach((cameraId, i) => {
                    this.destroyVideo(i);
                    // if (this.videos[i]) {
                    //   this.videos[i].remove();
                    // }
                });
            } else {
                this.hlsInstances.forEach((hls, i) => {
                    hls.stopLoad();
                    hls.detachMedia();
                    hls.destroy();
                    this.videos[i].pause();
                    this.videos[i].currentTime = 0;
                    this.videos[i].src = '';
                    this.videos[i].remove();
                });

                this.videoRef = undefined;
                this.hlsInstances = [];
                this.videos = undefined;
            }
        }
    }

    logVideoWatchTime(duration: number, id_camera: number, id_plan: number) {
        // in development already implemented
        console.log('logVideoWatchTime');
    }

    getCameraName(index: number): string {
        if (this.currentMosaic.cameras.length != 0 && this.currentMosaic.cameras[index] != undefined) {
            const camId = this.currentMosaic.cameras[index].id_camera;
            let cam = this.cameras ? this.cameras.find(camera => camera.id === camId) : null;
            if (cam) {
                return cam ? cam.alias : this.currentMosaic.cameras[index].alias;
            } else {
                cam = this.camerasShared ? this.camerasShared.find(camera => camera.id === camId) : null;
                return cam ? cam.alias : this.currentMosaic.cameras[index].alias;
            }
        } else {
            return null;
        }
    }

    getUserImage(index: number): string {
        if (this.currentMosaic.cameras.length != 0 && this.currentMosaic.cameras[index] != undefined) {
            const camId = this.currentMosaic.cameras[index].id_camera;
            const cam = this.cameras ? this.cameras.find(camera => camera.id === camId) : null;
            const camShared = this.camerasShared ? this.camerasShared.find(camera => camera.id === camId) : null;
            if (cam && !camShared) {
                return cam ? cam.user_picture : null;
            } else if (!cam && camShared) {
                return camShared ? camShared.user_picture : '../../../assets/img/placeholder.jpg';
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getUserInviteName(index: number): string {
        if (this.currentMosaic.cameras.length != 0 && this.currentMosaic.cameras[index] != undefined) {
            const camId = this.currentMosaic.cameras[index].id_camera;
            let cam = this.cameras ? this.cameras.find(camera => camera.id === camId) : null;
            if (cam) {
                return cam ? cam.name : '';
            }
            else {
                cam = this.camerasShared ? this.camerasShared.find(camera => camera.id === camId) : null;
                return cam ? cam.name : '';
            }
        }
        else {
            return null;
        }
    }
    // Busca o status da conexão da câmera para retornar ao junto a câmera
    getCameraStatus(index: number): boolean {
        // Verificar se currentMosaic e cameras existem
        if (!this.currentMosaic || !this.currentMosaic.cameras ||
            this.currentMosaic.cameras.length <= index) {
            return null;
        }

        const camera = this.currentMosaic.cameras[index];
        if (camera && camera.id_camera != -1 &&
            this.statusMosaic && this.statusMosaic[index] != undefined) {
            return this.statusMosaic[index];
        }
        return null;
    }

    selectVideo(index: number) {
        this.selectedVideo = this.selectedVideo === index ? -1 : index;
    }

    isSelected(index: number, status): boolean {
        const backgroundStyle = document.getElementById('backgroundStyle' + index);
        if (backgroundStyle) {
            if (status === null) {
                backgroundStyle.classList.add('with-image');
            } else {
                backgroundStyle.classList.add('without-image');
            }
        }
        return index === this.selectedVideo;
    }

    inMosaic(camera: Camera): boolean {
        if (camera !== null && camera != undefined) {
            if (this.currentMosaic && this.currentMosaic.cameras == null) {
                this.currentMosaic.cameras = [];
            }
            if (this.currentMosaic) {
                return this.currentMosaic.cameras.find(cameraId => cameraId.id_camera == camera.id || cameraId.id == camera.id) != null;
            }
            else {
                return false;
            }
        } else {
            return false;
        }

    }

    formatOwnerName(element) {
        const owner = element.split(' ');
        if (owner.length > 1) {
            this.ownerName = owner[0] + ' ' + owner.slice(-1);
        } else {
            this.ownerName = owner[0];
        }
        if (this.ownerName.length > 13) {
            const formatString = this.ownerName.substr(0, 13);
            const stringFormated = formatString + '...';
            this.ownerName = stringFormated;
        }
        return this.ownerName;
    }

    displayCamName(name: string): string {
        if (name != null) {
            let displayName = name;
            // Valida o tamanho da string, de modo que pelo tamanho, insere o elipsis no fim, não quebrando visualmente o tamanho da div
            if (displayName.length > 13) {
                const formatString = displayName.substr(0, 13);
                const stringFormated = formatString + '...';
                displayName = stringFormated;
            }
            return displayName;
        }
        else {
            return '';
        }
    }

    // Abre o modal de edição de informações da câmera
    openModalCameraUpdate(cam: Camera) {
        const camPayload = {
            ...cam
        };
        this.pauseVideos(this.currentMosaic);
        this.camerasOnMosaic = this.currentMosaic.cameras;
        this.store.dispatch(CameraActions.open_modal_update_camera({ payload: camPayload }));
    }

    // Mêtodo usado para salvar alterações no mosaico
    whenModalClose(close) {
        if (this.saveCameras && !close) {
            this.loadCameras();
            this.camerasOnMosaic = this.currentMosaic.cameras;
            this.currentMosaic.cameras = this.camerasOnMosaic;
            this.createGrid();
        } else {
            this.restartStreamings(true);
        }
    }

    restartStreamings(close: boolean) {
        this.initMosaic = close;
        if (this.currentMosaic) {
            this.currentMosaic.cameras.forEach((cameraId, i) => {
                this.playVideo(i);
            });
        }
        else if (this.queryVideos) {
            this.queryVideos.notifyOnChanges();
        }
    }

    updateCameraEdit() {
        this.modalClose = this.modal_open_camera$.subscribe(modalStatus => {
            if (Number(modalStatus) == CameraModal.Closed) {
                // this.store.dispatch(CameraActions.get_cameras({ user_sub: this.userSub, short: false, active: true }));
                // this.waiting = true;
                // this.store.dispatch(CameraActions.update_camera_infor_change_return(null));
            }
        });
    }

    confirmUpdateCamera() {
        this.updateCam = this.upCam$.subscribe(upStatus => {
            if (upStatus) {
                if (upStatus.status == OperationStatus.Success) {
                    this.loadCameras();
                    this.store.dispatch(CameraActions.close_modal_update_camera_confirm());
                    this.validationResponse.validationResponseHandler(200, 'camera-list', 'success-update-camera', 'cameras.success_update');
                    // showAlert('Os dados da sua câmera foram alterados com sucesso.', 'success');
                    // this.store.dispatch(CameraActions.get_cameras({ user_sub: this.userSub, short: false, active: true }));z
                    this.waiting = true;
                }
                else if (upStatus.status == OperationStatus.Fail) {
                    this.validationResponse.validationResponseHandler(400, 'camera-list', 'failure-update-camera', 'cameras.failure_update');
                // showAlert('Não foi possível alterar os dados da sua câmera.', 'danger');
                }
                this.store.dispatch(CameraActions.update_camera_change_feedback({ payload: OperationStatus.Unloaded }));
            }
        });
    }

    updateInfoCam(cam: Camera) {
        const userSub = localStorage.getItem('sub');
        const camera: Camera = {
            id: cam.id,
            alias: cam.alias,
            id_plan: cam.id_plan,
            address: {
                rua: cam['numero'],
                numero: cam['rua'],
                complemento: cam['complemento'],
                cep: cam['cep'],
                bairro: cam['bairro'],
                estado: cam['estado'],
                cidade: cam['cidade'],
                latitude: cam['latitude'],
                longitude: cam['longitude']
            },
            link_rtsp: cam.link_rtsp,
        };
        this.store.dispatch(CameraActions.update_camera_infor({
            camera: camera,
            user_sub: userSub,
            partner_sub: this.partnerSub
        }));
        this.waiting = true;
    }

    confirmDeleteFeedback() {
        this.deleteCam = this.delCam$.subscribe(delStatus => {
            if (delStatus) {
                if (delStatus.status == OperationStatus.Success) {
                    this.validationResponse.validationResponseHandler(200, 'camera-list', 'success-delete-camera', delStatus.message);
                    // showAlert('Sua câmera foi deletada.', 'success');
                    this.removeCamera(this.currentMosaicIndex);
                    this.currentMosaicIndex = null;
                    this.loadCameras();
                    this.loading = false;
                    this.waiting = true;
                    this.store.dispatch(CameraActions.get_user_mosaics({ user_sub: this.userSub }));
                }
                else if (delStatus.status == OperationStatus.Fail) {
                    this.validationResponse.validationResponseHandler(400, 'camera-list', 'failure-delete-camera', delStatus.message);
                    this.waiting = false;
                // showAlert('Não foi possível excluir sua Câmera.', 'danger');
                }
                this.store.dispatch(CameraActions.delete_camera_change_feedback({ payload: OperationStatus.Unloaded }));
            }
        });
    }

    // Abre modal de convidados para a câmera
    openModalInviteUser(cam: Camera) {
        localStorage.setItem('idCameraChoice', String(cam.id));
        this.store.dispatch(CameraActions.put_plan_max_invite_user({ payload: cam.plan_details[0]?.max_invites }));
        this.store.dispatch(CameraActions.put_id_invite_user({ payload: cam.id }));
        localStorage.setItem('cameraIdInvite', String(cam.id));
        localStorage.setItem('cameraName', cam.alias);
        this.store.dispatch(CameraActions.open_modal_invite_user());
        localStorage.setItem('inventoryClient', JSON.stringify(this.inventories));
        this.pauseVideos(this.currentMosaic);
    }

    updateNumberGuests() {
        this.modalClose = this.modal_open$.subscribe(modalStatus => {
            if (Number(modalStatus) == ModalState.Closed) {
                // this.store.dispatch(CameraActions.get_cameras({ user_sub: this.userSub, short: false, active: true }));
                this.waiting = true;
                this.store.dispatch(CameraActions.close_modal_invite_user_cancel());
            }
        });
    }

    goToAnalyticsPage(cam: Camera) {
        this.cameraData.setSharedData(cam);
        if (cam.created_off == false) {
            if (cam.active == true) {
                localStorage.setItem('previousRouter', this.router.url);
                this.router.navigateByUrl('/analytics/manage');
            }
        }
    }

    // Abre modal de analíticos da câmera
    openModalAnalytics(cam: Camera) {
        this.pauseVideos(this.currentMosaic);
        localStorage.setItem('idCameraChoice', String(cam.id));
        this.camerasOnMosaic = this.currentMosaic.cameras;
        this.store.dispatch(CameraActions.put_analytic_camera({ payload: cam }));
        this.store.dispatch(AnalyticActions.update_modal_state({ payload: ModalState.List }));
    }

    toggleDropdown() {
        this.isDropdownActive = !this.isDropdownActive;
    }

    getDimentionsMosaic(mosaic: Mosaic) {
        const mosaicFind = this.mosaicTemplate.find(m => m.id_mosaic_template === mosaic.id_mosaic_template);
        return mosaicFind ? '../../../assets/img/Icons/grid' + mosaicFind.height + 'x' + mosaicFind.width + '.svg' : '../../../assets/img/Icons/grid2x2.svg';
    }

    searchCameras() {
        const query = this.searchInputControl.value;
        if (!this.loadingCamera && !this.loadingGroup) {
            clearTimeout(this.timeOutHandler);
            this.timeOutHandler = setTimeout(() => {
                this.initCameras();
                if (this.selectedGroup) {
                    this.store.dispatch(CameraActions.get_group_cameras({
                        user_sub: this.userSub,
                        child_sub: this.selectedClient,
                        group_id: this.selectedGroup,
                        type_request: this.selectedGroup > 0 ? 'data' : 'cameras',
                        page: this.sumGroup,
                        limit: this.camLimit,
                        str_filter: query,
                        active: true
                    }));
                } else {
                    this.store.dispatch(CameraActions.get_cameras({
                        user_sub: this.userSub,
                        child_sub: this.selectedClient,
                        group_id: this.selectedGroup,
                        page: this.sum,
                        limit: this.camLimit,
                        str_filter: query,
                        short: false,
                        active: true
                    }));
                    this.store.dispatch(CameraActions.get_invited_cameras({
                        user_sub: this.userSub,
                        str_filter: query,
                        list_type: ListType.Live
                    }));
                }
                this.loadingCamera = true;
                this.loadingGroup = true;
            }, 800);
            setTimeout(() => {
                this.loadingCamera = false;
                this.loadingGroup = false;
            }, 5000);
        }
    }

    onScroll() {
        const query = this.searchInputControl.value;
        if (!this.loadingScroll) {
            if (this.sumGroup <= this.allPagesGroup && this.selectedGroup) {
                this.loadingScroll = true;
                this.sumGroup = this.actualGroup <= this.allPagesGroup ? this.sumGroup += 1 : this.sumGroup;
                this.store.dispatch(CameraActions.get_group_cameras({
                    user_sub: this.userSub,
                    child_sub: this.selectedClient,
                    type_request: this.selectedGroup > 0 ? 'data' : 'cameras',
                    page: this.sumGroup,
                    limit: this.camLimit,
                    group_id: this.selectedGroup,
                    str_filter: query,
                    active: true
                }));
            }
            if (this.sum <= this.allPages && !this.selectedGroup) {
                this.loadingScroll = true;
                this.sum = this.actual <= this.allPages ? this.sum += 1 : this.sum;
                this.totalAmountGroup = this.selectGroup ? 0 : this.totalAmountGroup;
                this.store.dispatch(CameraActions.get_cameras({
                    user_sub: this.userSub,
                    child_sub: this.selectedClient,
                    page: this.sum,
                    limit: this.camLimit,
                    group_id: this.selectedGroup,
                    str_filter: query,
                    short: false,
                    active: true
                }));
            }

            setTimeout(() => {
                this.loadingScroll = false;
            }, 15000);
        }
    }

    initCameras() {
        this.cameras = [];
        this.sum = 1;
        this.sumGroup = 1;
        this.totalAmount = 0;
        this.totalAmountGroup = 0;
        this.actual = 1;
        this.actualGroup = 1;
    }

    change(id: number | string) {
        if (this.activeList.findIndex(element => element == id) >= 0) {
            this.activeList = [];
        } else if (id == null) {
            this.activeList = [];
        }
        else {
            this.activeList = [id];
        }
    }
}
